import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type {
  CreateTicketPayload,
  Ticket,
  TicketAnalytics,
} from "#/types/tickets";

export const ticketsApi = {
  create: (
    body: CreateTicketPayload
  ): Promise<ApiResponse<CreateTicketPayload>> => api.post("/ticket", body),
  update: (
    id: number,
    body: Partial<CreateTicketPayload>
  ): Promise<ApiResponse<Ticket>> => api.patch(`/ticket/${id}`, body),
  getAll: (
    params: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Ticket[]>>> =>
    api.get("/ticket", { params }),
  createAndExportPdf: async (body: CreateTicketPayload): Promise<void> => {
    const response = await api.post<Blob>("/ticket/with-pdf", body, {
      responseType: "blob",
    });
    api.downloadFile(response.data, "tickets.pdf", "application/pdf");
  },
  analytics: (): Promise<ApiResponse<TicketAnalytics>> =>
    api.get("/ticket/analytics"),
};
